import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d3c6b1e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3c6b1e')) {
      api.createRecord('3d3c6b1e', component.options)
    } else {
      api.reload('3d3c6b1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d3c6b1e", function () {
      api.rerender('3d3c6b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/templateManage/index.vue"
export default component.exports